import React from 'react';
import BottomSheet from '../components/BottomSheet';

export default function SwitchRestaurantSheet({ open, onClose, restaurants = [], activeId }) {
  return (
    <BottomSheet open={open} onClose={onClose} title="Mes restaurants" height="auto">
      <div style={styles.note}>
        ⚠️ Multi-restaurant en bêta — l'app est connectée au premier établissement créé.
        La bascule active sera ajoutée prochainement.
      </div>

      <ul style={styles.list}>
        {restaurants.length === 0 && (
          <li style={styles.empty}>Aucun restaurant trouvé.</li>
        )}
        {restaurants.map((r) => {
          const isActive = r.id === activeId;
          return (
            <li key={r.id} style={styles.item}>
              <span aria-hidden style={{ ...styles.dot, ...(isActive ? styles.dotActive : styles.dotInactive) }} />
              <div style={styles.body}>
                <div style={styles.name}>{r.nom}</div>
                <div style={styles.meta}>
                  {[r.ville, r.type_cuisine].filter(Boolean).join(' · ') || 'Aucune ville renseignée'}
                </div>
              </div>
              {isActive && <span style={styles.activeTag}>Actif</span>}
            </li>
          );
        })}
      </ul>
    </BottomSheet>
  );
}

const styles = {
  note: {
    background: '#FFF4D6',
    color: '#1A1A1A',
    padding: 12,
    borderRadius: 12,
    fontSize: 12,
    lineHeight: 1.4,
    marginBottom: 16,
  },
  list: {
    margin: 0,
    padding: 0,
    listStyle: 'none',
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
  },
  empty: {
    padding: 16,
    fontSize: 13,
    color: '#9A9A9A',
    textAlign: 'center',
  },
  item: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    padding: 14,
    background: '#FFFFFF',
    borderRadius: 12,
    border: '1px solid #EDEAE3',
  },
  dot: {
    width: 8,
    height: 8,
    borderRadius: '50%',
    flexShrink: 0,
  },
  dotActive: { background: '#2D7A4A' },
  dotInactive: { background: '#D7D7D2' },
  body: { flex: 1, minWidth: 0 },
  name: { fontSize: 14, fontWeight: 700, color: '#1A1A1A' },
  meta: { fontSize: 12, color: '#6B6B6B', marginTop: 2 },
  activeTag: {
    fontSize: 11,
    fontWeight: 700,
    color: '#2D7A4A',
    textTransform: 'uppercase',
    letterSpacing: 0.5,
  },
};
